export const isRovoSystemSpaceKey = (spaceKey?: string | null): boolean => {
	if (!spaceKey) {
		return false;
	}
	return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
